// extracted by mini-css-extract-plugin
export default {"boxContainer":"auth_boxContainer__0CQLT","otpBox":"auth_otpBox__0hI5+"};